// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "geo_region_id",
                Decco.intToJson(v.geo_region_id)
              ],
              [
                "vehicle_id",
                Decco.intToJson(v.vehicle_id)
              ],
              [
                "from",
                Decco.intToJson(v.from)
              ],
              [
                "size",
                Decco.intToJson(v.size)
              ]
            ]);
}

export {
  t_encode ,
  
}
/* No side effect */
